<script>
    import { navigate } from "svelte-routing";

    function signout () {
        navigate("/login");
    }
</script>

<button title="Anmelden" on:click={signout}>Anmelden</button>

<style>
    button {
        color: #666;
        background-color: #F0F0F0;
        border: transparent;
        border-radius: 0.5rem;
        padding: 0.4rem 1rem;
        margin: 0;
    }
</style>